import CuentaCorrienteTable from "../components/Table";
import { useToast } from "../../../../../Hooks/UseToast";
import { useCuentaCorriente } from "../hooks/useCuentaCorriente";
import { useMemo, useState } from "react";
import ModalManager from "../modals/ModalManager";
import { TOOLBAR_ACTIONS } from "../config/TOOLBAR_ACTIONS";
import { MODAL_TYPES } from "../config/MODALES_TYPES";
import { useCuentaCorrienteSoloPendientes } from "../hooks/useCuentaCorrienteSoloPendientes";
import { DEFAULT_FILTERS } from "../config/DEFAULT_FILTERS";
import { ROW_ACTIONS } from "../config/ROW_ACTIONS";
import { verEnviarPDFenvasado } from "../../../../../services/services";
import { useExportarPDF } from "../hooks/useExportPdf";
import { useExportarExcel } from "../hooks/useExportExcel";
import { TABLE_VARIANTS } from "../config/TABLE_VARIANTS";
import { useCountPendingRequest } from "../hooks/useCountPendingReceipt";
import { useCountNotes } from "../hooks/useCountNotes";

const CuentaCorrientePage = ({ cliente }) => {
  const [filtros, setFiltros] = useState(DEFAULT_FILTERS);

  const { data: countNotes, refresh: refreshCountNotes } = useCountNotes(
    cliente.id,
  );

  const { data, loading, refresh } = useCuentaCorriente(cliente, filtros);
  const {
    data: dataSoloPendientes,
    loading: loadingSoloPendientes,
    refresh: refreshSoloPendientes,
  } = useCuentaCorrienteSoloPendientes(cliente);

  const {
    data: countPendingReceipt,
    loading: loadingPendingReceipt,
    error: errorPendingReceipt,
    refresh: refreshCountSoloPendientes,
  } = useCountPendingRequest(cliente);

  const { Toast, showToast } = useToast();
  const [modal, setModal] = useState(null);
  const [soloPendientes, setSoloPendientes] = useState(false);

  //Exporters
  const { execute: exportarPDF } = useExportarPDF();
  const { execute: exportarExcel } = useExportarExcel();

  // console.log({
  //   soloPendientes,
  //   loading,
  //   loadingSoloPendientes,
  // });

  const refreshAll = async () => {
    await Promise.all([
      refresh(),
      refreshSoloPendientes(),
      refreshCountSoloPendientes(),
      refreshCountNotes(),
    ]);
  };

  const variant = soloPendientes
    ? TABLE_VARIANTS.PENDIENTE
    : TABLE_VARIANTS.COMPLETO;

  const currentData = soloPendientes ? dataSoloPendientes : data;
  const currentLoading = soloPendientes ? loadingSoloPendientes : loading;

  const openModal = (type, props = {}) => {
    setModal({ type, ...props });
  };

  const handleToolbarAction = ({ type }) => {
    switch (type) {
      case TOOLBAR_ACTIONS.CREAR_RECIBO:
        openModal(MODAL_TYPES.CREAR_RECIBO, { clienteData: cliente });
        break;

      case TOOLBAR_ACTIONS.APLICAR_RECIBO:
        openModal(MODAL_TYPES.APLICAR_RECIBO, {
          clienteData: cliente,
        });
        break;

      case TOOLBAR_ACTIONS.APLICAR_FILTROS:
        openModal(MODAL_TYPES.FILTROS, { filtros, onApply: setFiltros });
        break;

      case TOOLBAR_ACTIONS.ABRIR_NOTAS:
        openModal(MODAL_TYPES.ABRIR_NOTAS, {
          idCliente: cliente.id,
          nombreCliente: cliente.razon_social,
          envasado: 1,
          refresh: refreshCountNotes,
        });
        break;

      case TOOLBAR_ACTIONS.VER_SOLO_PENDIENTES:
        setSoloPendientes(true);
        break;

      case TOOLBAR_ACTIONS.EXPORTAR_PDF:
        openModal(MODAL_TYPES.FILTROS_EXPORTER, {
          onApply: (filtros) =>
            exportarPDF(cliente.id, cliente.id_negocio_cliente, filtros),
          filtros,
        });
        break;

      case TOOLBAR_ACTIONS.EXPORTAR_EXCEL:
        openModal(MODAL_TYPES.FILTROS_EXPORTER, {
          onApply: (filtros) =>
            exportarExcel(cliente.id, cliente.id_negocio_cliente, filtros),
          filtros,
        });
        break;

      case TOOLBAR_ACTIONS.LIMPIAR_FILTROS:
        setFiltros(DEFAULT_FILTERS);
        break;

      case TOOLBAR_ACTIONS.DESACTIVAR_SOLO_PENDIENTES:
        setSoloPendientes(false);
        break;

      default:
        break;
    }
  };

  const handleRowAction = ({ type, row }) => {
    switch (type) {
      case ROW_ACTIONS.DETALLE_RECIBO:
        openModal(MODAL_TYPES.DETALLE_RECIBO, {
          id: row.id,
          clienteData: cliente,
        });
        break;

      case ROW_ACTIONS.ANULAR_RECIBO:
        openModal(MODAL_TYPES.ANULAR_RECIBO, {
          id: row.id,
        });
        break;

      case ROW_ACTIONS.DESAPLICAR_RECIBO:
        openModal(MODAL_TYPES.DESAPLICAR_RECIBO, {
          id: row.id,
        });
        break;

      case ROW_ACTIONS.DETALLE_FACTURA:
        openModal(MODAL_TYPES.DETALLE_FACTURA, { row, clienteData: cliente });
        break;

      case ROW_ACTIONS.ANULAR_FACTURA:
        openModal(MODAL_TYPES.ANULAR_FACTURA, { row });
        break;

      case ROW_ACTIONS.VER_FACTURA:
        verEnviarPDFenvasado(row.id, 0);
        break;

      case ROW_ACTIONS.ENVIAR_POR_MAIL:
        openModal(MODAL_TYPES.ENVIAR_POR_MAIL, {
          id: row.id,
        });
        break;

      default:
        break;
    }
  };

  const cantidadFiltrosActivos = useMemo(() => {
    return Object.entries(filtros).reduce((cantidad, [key, value]) => {
      const defaultValue = DEFAULT_FILTERS[key];

      if (Array.isArray(value)) {
        return cantidad + (value.length > 0 ? 1 : 0);
      }

      return cantidad + (value !== defaultValue ? 1 : 0);
    }, 0);
  }, [filtros]);

  return (
    <>
      <CuentaCorrienteTable
        data={currentData?.movimientos ?? []}
        totales={currentData?.saldos ?? {}}
        loading={currentLoading}
        onAction={handleRowAction}
        onToolbarAction={handleToolbarAction}
        showToast={showToast}
        filtrosActivos={cantidadFiltrosActivos}
        variant={variant}
        cantidadDeRecibosPendientes={countPendingReceipt}
        countNotes={countNotes}
      />

      <ModalManager
        modal={modal}
        onClose={() => setModal(null)}
        refresh={refreshAll}
        showToast={showToast}
      />
      {Toast}
    </>
  );
};

export default CuentaCorrientePage;
